<div class="container container_type_main">
  <ng-container *ngIf="!fileSelected else fragmentSelector">
    <div class="subtitle h2 mt-32">{{ 'subscriber-ugc-page.title' | translate }}</div>
    <div class="my-track__subtext">{{ 'subscriber-ugc-page.subtext' | translate }}</div>
    <div *ngIf="!isLoaded" class="modal__loader with-icon"></div>
    <div *ngIf="isLoaded && !privetPlus ">
      <div class="info-hint">{{ 'subscriber-ugc-page.subscription-hint' | translate }}</div>
      <div class="my-track__button">
        <a class="button" routerLink="/subscriber/subscriptions">{{ 'subscriber-ugc-page.title-privet-plus' | translate}}</a>
      </div>
    </div>
    <div class="track-upload" *ngIf="privetPlus">
      <input type="file" class="track-upload__input" accept="audio/mpeg" (change)="onFileSelected($event)" #fileUpload/>
      <div class="track-upload__text" [innerHtml]="'subscriber-ugc-page.file-format-hint' | translate"></div>
    </div>
    <div class="my-track__uploader" *ngIf="selectedFile">
      <div class="my-track__uploader-track">
        <div class="my-track__uploader-track-name">{{ selectedFile.name }}</div>
        <div class="my-track__uploader-track-remove icon-trash" (click)="clearSelectedFile()"></div>
      </div>
      <div class="my-track__uploader-size">{{ 'subscriber-ugc-page.file-size' | translate: {size: selectedFile.size} }}</div>
      <div class="my-track__uploader-error" *ngIf="selectedFileError">{{ selectedFileError | translate }}</div>

    </div>
    <div class="my-track__term" *ngIf="privetPlus">
      <label class="checkbox">
        <input type="checkbox" class="checkbox__input" [(ngModel)]="termsAccepted" (ngModelChange)="updateNextButtonActivity()"/>
        <div class="checkbox__style-container">
          <div class="checkbox__style"></div>
        </div>
        <div class="checkbox__label" [innerHtml]="'subscriber-ugc-page.terms-of-use-text' | translate"></div>
      </label>
    </div>
    <div class="my-track__button" *ngIf="privetPlus">
      <div class="button" [class.button_status_disabled]="!nextEnabled" (click)="showFragmentSelector()">{{ 'subscriber-ugc-page.next' | translate }}</div>
    </div>
  </ng-container>

  <app-mobile-apps-banner></app-mobile-apps-banner>
</div>

<ng-template #fragmentSelector>
  <div class="backlink with-icon" (click)="showFileSelector()">{{ 'subscriber-ugc-page.back-to-file-selection' | translate }}</div>
  <div class="subtitle h2 mt-32">{{ 'subscriber-ugc-page.select-fragment' | translate }}</div>
  <div class="my-track__subtext">{{ 'subscriber-ugc-page.select-fragment-hint' | translate }}</div>
  <div class="info-hint" *ngIf="!subscribed">{{ 'subscriber-ugc-page.subscription-hint' | translate }}</div>

  <div class="my-track__uploader">
    <div class="my-track__uploader-track">
      <div class="my-track__uploader-track-name">{{ selectedFile.name }}</div>
    </div>
    <div class="my-track__uploader-size">{{ 'subscriber-ugc-page.file-size' | translate: {size: selectedFile.size} }}</div>
  </div>

  <div class="my-track__fragment" #trackFragment>
    <section class="track-cut">
      <section class="track-cut__container">
        <section data-track-cut-current="data-track-cut-current" class="track-cut__current" [class.active]="wavesurferInitialized"></section>
        <section class="track-cut__preview" [class.active]="wavesurferInitialized">
          <span data-track-cut-preview-start="data-track-cut-preview-start" class="track-cut__preview__label" *ngIf="currentTime">{{currentTime}}</span>
          <span data-track-cut-preview-end="data-track-cut-preview-end" class="track-cut__preview__label" *ngIf="endTime">{{endTime}}</span>
          <div class="track-cut__preview-container-wrapper">
            <section data-track-cut-preview-wave="1" class="track-cut__preview-container"></section>
          </div>
        </section>
      </section>
      <section class="track-cut__preview-controls">
        <span [title]="'subscriber-ugc-page.play-pause' | translate" class="track-cut__preview-control track-cut__preview-control-play" [class.active]="playing" (click)="togglePlay()">
          <span class="icon icon-play"></span>
          <span class="icon icon-pause"></span>
        </span>
        <span [title]="'subscriber-ugc-page.reset' | translate" class="track-cut__preview-control track-cut__preview-control-refresh" (click)="resetWaveSurfer()">
          <span class="icon icon-repeat"></span>
        </span>
      </section>
    </section>
  </div>
  <div class="my-track__button">
    <div class="button" [class.button_type_load]="requestInProgress" [class.button_status_disabled]="!wavesurferReady"  (click)="uploadTrack()">{{ 'subscriber-ugc-page.upload-track' | translate }}</div>
  </div>
</ng-template>
